import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/Services/auth.service';

@Component({
  selector: 'app-executive-side-nav',
  templateUrl: './executive-side-nav.component.html',
  styleUrls: ['./side-nav.shared.scss','./executive-side-nav.component.css'],

})
export class ExecutiveSideNavComponent implements OnInit {

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
  }

  hasAccess(permissions: string[]) {
    return this.auth.hasAnyPermission(permissions);
  }

  stopDropdownClose(event: Event) {
    event.stopPropagation();
  }

}
